import { render, staticRenderFns } from "./AddPaymentModal.vue?vue&type=template&id=2bc70e03&scoped=true"
import script from "./AddPaymentModal.vue?vue&type=script&lang=js"
export * from "./AddPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./AddPaymentModal.vue?vue&type=style&index=0&id=2bc70e03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc70e03",
  null
  
)

export default component.exports